export const HIERARCY_LEVEL = {
    CATEGORY: 'CATEGORY',
    SUBCATEGORY: 'SUBCATEGORY',
    DEPARTMENT: 'DEPARTMENT'
}